import React from 'react';
import MediaQuery from 'react-responsive';

import Button from '../../../components/UI/Button/Button';
import FormGrid from '../../../components/UI/FormGrid/FormGrid';
import Textbox from '../../../components/UI/Textbox/Textbox';
import Checkbox from '../../../components/UI/Checkbox/Checkbox';
import DatePicker from '../../../components/UI/DatePicker/DatePicker';
import Select from '../../../components/UI/Select/Select';
import Aux from '../../../hoc/Auxi/Auxi';
import {languageLevels} from '../../../shared/constants';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';

/**
* @desc Language in candidate profile section
* @param props
* @return DOM element
*/
const Language = (props) => {
  const options = Object.keys(languageLevels).map((language) => {
    return <option >{language.replace(/(^| )(\w)/g, s => s.toUpperCase())}</option>
  });
 const skill = (props.skill ? props.skill[0].toUpperCase() + props.skill.slice(1) : "");
  return (
    <React.Fragment>
      <div>
        <Textbox 
          id="language" 
          label={"Language"} 
          placeholder="" 
          value={props.language.replace(/(^| )(\w)/g, s => s.toUpperCase())} 
          onChange={(event) => props.handleLanguageChange(event, props.index)}
          inValid={props.inValid}
          onBlur={(event) => props.handleLanguagesOnBlur(event,props.index)}/>
      </div>
      <Select 
        id="skill" 
        label="Level" 
        value={skill} onChange={(event) => props.handleLanguageChange(event, props.index)}>
        {options}
      </Select>
    </React.Fragment>
  )
}

/**
* @desc Languages in candidate profile section
* @param props
* @return DOM element
*/
const Languages = (props) => {
  const updateText = props.langActive =="updated" ? "Updated" : "Update";
  const inValid = props.errorMsg !== null && props.errorPosition === "language";
  const disabled = props.langActive =="update" ? 'disabled' : "";
  return (
    <Aux>
      <div className="profile-edit__item">
        <MediaQuery query="(min-device-width: 768px)">
          <FormGrid grid="auto auto auto auto">
            {props.candidate.languages.map((lang, index) => (
              <Language 
                key={index} 
                index={index} 
                language={lang.language} 
                skill={lang.skill} 
                handleLanguageChange={props.handleLanguageChange}
                inValid={inValid?"Invalid":""}
                handleLanguagesOnBlur={props.handleLanguagesOnBlur}/>
            ))}
          </FormGrid>
        </MediaQuery>
        
        <MediaQuery query="(max-device-width: 767px)">
          <FormGrid grid="auto">
            {props.candidate.languages.map((lang, index) => (
              <Language 
                key={index} 
                index={index} 
                language={lang.language} 
                skill={lang.skill} 
                handleLanguageChange={props.handleLanguageChange}  
                inValid={inValid?"Invalid":""}
                handleLanguagesOnBlur={props.handleLanguagesOnBlur}/>
            ))}
          </FormGrid>
        </MediaQuery>      
      </div>
      <div className="profile-edit__section__buttons">
        <MediaQuery query="(min-device-width: 768px)">
          <Button uistyle="secondary" className="profile-edit__add-button" onClick={props.addLanguage}>+ Add Language</Button>
        </MediaQuery>        
        <MediaQuery query="(max-device-width: 767px)">
          <Button uistyle="secondary" className="profile-edit__add-button" buttonicon="add" buttonIconAlone={true} onClick={props.addLanguage}></Button>
        </MediaQuery>  
        <Button className={props.langActive} disabled={disabled} onClick={(event)=>props.handleUpdateProfile(event,"langActive")}>{updateText}</Button>
      </div>
    </Aux>
  );
}

export default Languages;


// WEBPACK FOOTER //
// ./src/components/Recruiter/Languages/Languages.js